<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { adminMe, clearAuth, getAdmin, type AdminInfo } from '../api';
import AuditCertifications from './AuditCertifications.vue';
import AuditRoleApplications from './AuditRoleApplications.vue';
import AuditReports from './AuditReports.vue';
import AuditDirectoryChanges from './AuditDirectoryChanges.vue';
import AuditPosts from './AuditPosts.vue';
import AuditTribes from './AuditTribes.vue';

const router = useRouter();
const admin = ref<AdminInfo | null>(getAdmin());
const activeTab = ref('registration');

onMounted(async () => {
  try {
    admin.value = await adminMe();
  } catch (e) {
    const err = e as { httpStatus?: number };
    if (err.httpStatus === 401) {
      router.replace('/login');
      return;
    }
    ElMessage.error('拉取当前管理员信息失败');
  }
});

function onLogout() {
  clearAuth();
  router.replace('/login');
}
</script>

<template>
  <el-container style="min-height: 100vh;">
    <el-header class="header">
      <div class="title">MBA圈 · 审核员后台</div>
      <div class="right" v-if="admin">
        <span class="muted">{{ admin.displayName || admin.username }}</span>
        <el-tag size="small" style="margin-left: 8px">{{ admin.role }}</el-tag>
        <el-button size="small" link type="danger" @click="onLogout" style="margin-left: 12px">
          退出
        </el-button>
      </div>
    </el-header>
    <el-main class="main">
      <el-tabs v-model="activeTab" class="pool-tabs">
        <el-tab-pane label="注册审核池" name="registration">
          <AuditCertifications />
        </el-tab-pane>
        <el-tab-pane label="入驻审核池" name="enrollment">
          <AuditRoleApplications />
        </el-tab-pane>
        <el-tab-pane label="课程审核池" name="course" disabled>
          <el-alert type="info" :closable="false">P3 期启用</el-alert>
        </el-tab-pane>
        <el-tab-pane label="内容审核池" name="content">
          <AuditDirectoryChanges />
        </el-tab-pane>
        <el-tab-pane label="广场机审池" name="plaza" lazy>
          <AuditPosts v-if="activeTab === 'plaza'" />
        </el-tab-pane>
        <el-tab-pane label="部落审核池" name="tribe" lazy>
          <AuditTribes v-if="activeTab === 'tribe'" />
        </el-tab-pane>
        <el-tab-pane label="仲裁池" name="arbitration" disabled>
          <el-alert type="info" :closable="false">P4 期启用</el-alert>
        </el-tab-pane>
        <el-tab-pane label="举报池" name="report" lazy>
          <AuditReports v-if="activeTab === 'report'" />
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </el-container>
</template>

<style scoped>
.header {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  border-bottom: 1px solid #e4e7ed;
}
.title { font-size: 18px; font-weight: 600; }
.right { display: flex; align-items: center; }
.muted { color: #666; font-size: 14px; }
.main { padding: 16px; background: #f5f5f7; }
.pool-tabs :deep(.el-tabs__content) { overflow: visible; }
</style>
